import {CSSClassName as ThemedLinkCSSClassName} from "../components/uiElements/ThemedLink";

const 	REGEX_URL 			= /(?:\s)(f|ht)tps?:\/\/([^\s\t\r\n<]*[^\s\t\r\n<)*_,\.])/g, //regex for urls
		REGEX_USER 			= /\B@([a-zA-Z0-9_]+)/g, //regex for @users
		REGEX_HASHTAG 		= /\B(#[Ã¡-ÃºÃ-ÃÃ¤-Ã¼Ã-Ãa-zA-Z0-9_]+)/g, //regex for #hashtags
		TwitterSearchLink 	= "https://twitter.com/hashtag/";


/**
 * Generate an anchor tag providing URL. Also follows the same style as the ThemedLink React Component
 * @param url
 * @param text
 * @param useDarkTheme
 * @return {string}
 */
function generateLink(url, text, useDarkTheme){
	return `<a href="${url}" class="${ThemedLinkCSSClassName} ${useDarkTheme ? ThemedLinkCSSClassName+"--dark" : "" }" rel="noopener noreferrer" target="_blank">${text}</a>`;
}

/**
 * Parse raw tweet text inserting links in places of Hashtags, links and mentions
 * @param tweetText - raw tweet text
 * @return {*}
 */
export default function parseTweeTtext(tweetText, useDarkTheme) {

	tweetText = tweetText.replace(REGEX_URL, (url) => {
		let link = generateLink(url,  url, useDarkTheme);
		return url.replace(url, link);
	});

	tweetText = tweetText.replace(REGEX_USER, (user) => {
		let userOnly = user.slice(1),
			url = `http://twitter.com/${userOnly}`,
			link = generateLink(url,  user, useDarkTheme);
		return user.replace(user, link);
	});

	tweetText = tweetText.replace(REGEX_HASHTAG, (hashtag) => {
		let hashtagOnly = hashtag.slice(1),
			url = TwitterSearchLink + hashtagOnly,
			link = generateLink(url, hashtag, useDarkTheme);
		return hashtag.replace(hashtag, link);
	});

	return tweetText;
};